import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Router from './routes/router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { useAuth } from "./hooks/useAuth";
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Ho_Chi_Minh');

function App() {
  useAuth();
  return (
    <>
      <Router />
      <ToastContainer
        position="top-right"
        autoClose={3000}
      />
    </>
  );
}

export default App;
